/* Flip Cards - TT — tap a card to turn it over. Stepping through them is <tt-carousel>'s job. */
(() => {
  if (window.ttFlipCardsReady) return;
  window.ttFlipCardsReady = true;

  document.addEventListener('click', (event) => {
    const card = event.target.closest('[data-flip]');
    if (!card) return;
    card.setAttribute('aria-pressed', card.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
  });
})();
